import { axiosClientv1 } from "./apiClient";
import { ApiResponse } from "../Types";

export const GetPurchasePayments = async (params: {
  page: number;
  limit: number;
  search?: string;
  purchase_id?: string;
  supplier_id?: string;
}): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.get(`/purchase-payments`, { params });
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message:
        error?.response?.data?.message || "Failed to load purchase payments.",
      data: { data: [], total: 0 },
      error: {
        code: error?.response?.status || 500,
        type: "server_error",
      },
    };
  }
};

export const CreatePurchasePayment = async (payload: {
  purchase_id: string;
  amount: number;
  payment_date: string;
  payment_method_id: string;
  bank_account_id?: string | null;
  cheque_no?: string | null;
  cheque_date?: string | null;
  payee?: string | null;
  note?: string | null;
  store_id?: string;
}): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.post(
      `/purchase-payments/create`,
      payload,
    );
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message:
        error?.response?.data?.message || "Failed to record purchase payment.",
      error: {
        code: error?.response?.status || 400,
        type: "bad_request",
      },
    };
  }
};

export const DeletePurchasePayment = async (
  id: string,
): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.post(`/purchase-payments/delete`, {
      id,
    });
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message:
        error?.response?.data?.message || "Failed to delete purchase payment.",
      error: {
        code: error?.response?.status || 400,
        type: "bad_request",
      },
    };
  }
};
